import * as React from 'react'
import { slugifyWithSlashes } from 'utils/slugify'
/**
 * Hook to generate a brand URL based on the brand name and path.
 * It checks if the brand is one of the self-brands and constructs the URL accordingly.
 * the brand shoulb be translated to a slug with slashes.
 * @param {string} brand - The brand name.
 * @param {string} brandPath - The path to the brand category.
 * @returns {string} - The constructed brand URL or an empty string if not a self-brand.
 */
export default function useBrandUrl(brand: string, brandPath: string) {
  return React.useMemo(() => {
    const isSelfBrand = [
      'VEGA',
      'PULSIVA',
      'JOBELINE',
      'ERWIN M.',
      'V-Touch'
    ].includes(brand)

    return isSelfBrand
      ? slugifyWithSlashes(`/category/${brandPath}/${brand}/`)
      : ''
  }, [brand, brandPath])
}
